import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    IconButton,
    TextField,
    CircularProgress
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ReopenModal = ({ open, onClose, onConfirm ,loading}) => {
    const [comment, setComment] = useState('');

    const handleConfirm = () => {
        onConfirm(comment);
        setComment('');
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: '8px',
                    padding: 0,
                    minHeight: 'fit-content',
                    maxHeight: 'fit-content'
                }
            }}
        >
            <DialogTitle 
                sx={{ 
                    display: 'flex', 
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '0 16px',
                    backgroundColor: '#102A62',
                    margin: 0,
                    width: '100%',
                    height: '50px',
                    boxSizing: 'border-box',
                    textAlign: 'center'
                }}
            >
                <Typography
                    sx={{
                        color: '#FFFFFF',
                        fontFamily: 'Montserrat',
                        fontWeight: 600,
                        fontSize: '20px',
                        textAlign: 'center'
                    }}
                >
                    Confirmation
                </Typography>
                <IconButton onClick={onClose} sx={{ color: '#FFFFFF', padding: 0 }}>
                </IconButton>
            </DialogTitle>
            <DialogContent 
                sx={{ 
                    padding: '20px',
                    overflow: 'hidden',
                    marginTop: '20px',
                }}
            >
                <Typography
                    sx={{
                        color: '#000000DE',
                        fontFamily: 'Montserrat',
                        fontSize: '16px',
                        lineHeight: '24px',
                        marginBottom: '20px'
                    }}
                >
                    You are trying to reopen the surveys. Do you want to proceed?
                </Typography>
                <TextField
                    fullWidth
                    multiline
                    focused
                    rows={4}
                    label="Comments"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    InputLabelProps={{
                        sx: {
                            color: '#FF0000', // Red color for label
                            '&.Mui-focused': {
                                color: '#FF0000', // Keep red color when focused
                            }
                        }
                    }}
                    sx={{
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '5px',
                            '& fieldset': {
                                borderColor: '#C4C4C4',
                            },
                            '&:hover fieldset': {
                                borderColor: '#C4C4C4',
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: '#C4C4C4',
                            },
                        },
                    }}
                />
            </DialogContent>
            <DialogActions 
                sx={{ 
                    padding: '0 20px 20px 20px',
                    justifyContent: 'center',
                    gap: 6
                }}
            >
                <Button
                    onClick={onClose}
                    variant="outlined"
                    sx={{
                        color: 'white',
                        borderColor: '#62636C',
                        background: 'transparent',
                        background: '#62636C',
                        textTransform: 'none',
                        fontFamily: 'Montserrat',
                        '&:hover': {
                            color: 'white',
                            background: '#62636C',

                        }
                    }}
                >
                    No
                </Button>
                <Button
                    onClick={handleConfirm}
                    variant="contained"
                    disabled={!comment.trim() || loading}
                    sx={{
                        backgroundColor: '#004F9F',
                        color: 'white',
                        textTransform: 'none',
                        fontFamily: 'Montserrat',
                        '&:hover': {
                            backgroundColor: '#004F9F'
                        },
                        '&.Mui-disabled': {
                        color: 'white',
                            backgroundColor: '#004F9F',
                            opacity: 0.5,

                        }
                    }}
                >
                  {loading && <CircularProgress size={20}  style={{position:'absolute'}}/>}  Yes
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ReopenModal;